import { MainView, NoAccessView } from '@repo/ui/Views';
import CreateSubAccountForm from '../components/CreateSubAccountForm';
import { useAccount } from '@/hooks/useAccount';
import COUNT_SUB_ACCOUNTS_Q from '../gql/countSubAccounts.gql';
import RedirectToAccountOverview from '@/features/account_overview/components/RedirectToAccountOverview';
import { useQuery } from '@apollo/client/react';
import { Card } from '@repo/ui/Card';
import { ButtonLink } from '@repo/ui/Button';
import { POLICIES } from '@/lib/Authorization';
import { useUser } from '@repo/hooks/useUser';
import { AccountFlagOverrideBehaviour } from '@repo/types/Models';

const CreateSubAccount = () => {
  const account = useAccount();
  const accountId = account.id;
  const user = useUser();

  // const { loading, data } = useQuery(COUNT_SUB_ACCOUNTS_Q);

  // const count = data?.countSubAccounts?.count;

  // const accountMaxSubAccountBehaviour = account.overrideMaxSubAccounts;
  // const accountPlanMaxSubAccounts = account.servicePlan?.maxSubAccounts;
  // const maxSubAccounts =
  //   accountMaxSubAccountBehaviour === AccountFlagOverrideBehaviour.PLAN_ONLY
  //     ? accountPlanMaxSubAccounts
  //     : account.maxSubAccounts;

  // const accountCanCreateSubAccount =
  //   typeof count === 'number' &&
  //   typeof maxSubAccounts === 'number' &&
  //   (maxSubAccounts === -1 || count < maxSubAccounts);

  const userCanCreateSubAccounts = POLICIES['accounts:create'](user);

  return (
    <MainView title={'Create new sub account'}>
      {account.parentAccount ? (
        <RedirectToAccountOverview />
      ) : userCanCreateSubAccounts ? (
        <CreateSubAccountForm accountId={accountId} />
      ) : !userCanCreateSubAccounts ? (
        <NoAccessView />
      ) : // ) : !accountCanCreateSubAccount ? (
      //   <Card
      //     title={`Max number of sub accounts already reached: ${maxSubAccounts}`}
      //     className="max-w-xl"
      //   >
      //     <p className="mb-6">
      //       The maximum number of sub accounts for this account has been
      //       reached.
      //     </p>

      //     <ButtonLink href={`/a/${accountId}/sub-accounts`}>
      //       Go back to account sub accounts
      //     </ButtonLink>
      //   </Card>
      null}
    </MainView>
  );
};

export default CreateSubAccount;
